import React from 'react';

const features = [
  {
    title: 'Real-Time Industry Experience',
    description: 'Gain authentic workplace experience in real organizational settings. Work on live projects, interact with clients, and meet actual deadlines.',
    badges: ['Live Projects', 'Client Interaction', 'Expert Mentorship'],
    icon: 'bi-bullseye',
    
  },
  {
    title: 'Career-Ready Training',
    description: 'Prepare to "hit the ground running" with comprehensive training that makes you job-ready from day one of your professional career.',
    badges: ['Job Ready', 'Confidence', 'KRA Mastery'],
    icon: 'bi-briefcase-fill',
   
  },
  {
    title: 'Risk-Free Learning',
    description: 'Learn in a semi-competitive atmosphere without the pressure of harsh targets. Make mistakes and learn without jeopardizing your career prospects.',
    badges: ['Safe Learning', 'Paid Stipend', 'No Pressure'],
    icon: 'bi-shield-lock-fill',
    
  },
  {
    title: 'Hands-on Experience',
    description: 'Focus on experiential learning by observing seniors and working on projects systematically, gathering both theoretical concepts and practical application.',
    badges: ['Experiential', 'Systematic', 'Practical'],
    icon: 'bi-lightbulb-fill',
   
  },
  {
    title: 'Enhanced Employability',
    description: 'Develop essential soft skills including problem-solving, decision-making, and communication that are crucial for professional success.',
    badges: ['Soft Skills', 'Problem Solving', 'Decision Making'],
    icon: 'bi-bar-chart-fill',
    
  },
  {
    title: 'Industry Recognition',
    description: 'Gain industry-recognized credentials that significantly boost your employment prospects and demonstrate your commitment to professional excellence.',
    badges: ['Certified', 'Recognized', 'Credible'],
    icon: 'bi-award-fill',
    
  }
];

const OJTFeatures = () => {
  return (<div className='otg-features-div'>  <div className="container otg-features-div py-5">
      <h2 className="text-center fw-bold text-primary mb-3">
        Why Choose Our OJT Program?
      </h2>
      <p className="text-center text-muted mb-5">
        Discover the unique advantages that make our program the preferred choice for ambitious professionals
      </p>

      <div className="row g-4">
        {features.map((feature, idx) => (
          <div className="col-md-4" key={idx}>
            <div className={`card border-0 shadow h-100`}>
             
                <div className={`otg-card-header text-center  fs-1 mb-3`}>
                  <i className={`bi text-white ${feature.icon} `}></i>
               
                <h5 className="card-title text-white fw-bold mb-5">{feature.title}</h5> </div>
                <p className="card-text text-center py-5 text-muted">{feature.description}</p>
                <div className="d-flex flex-wrap justify-content-center mb-5 gap-2 mt-3">
                  {feature.badges.map((badge, bIdx) => (
                    <span key={bIdx} className="badge otg-features-div text-dark border">
                      {badge}
                    </span>
                  ))}
                </div>
              </div>
            </div>
        
        ))}
      </div>

    
    </div>
  </div>
  );
};

export default OJTFeatures;
